import { render } from "./Kanryo.vue?vue&type=template&id=502a46ef&scoped=true"
import script from "./Kanryo.vue?vue&type=script&lang=js"
export * from "./Kanryo.vue?vue&type=script&lang=js"

import "./Kanryo.vue?vue&type=style&index=0&id=502a46ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-502a46ef"

export default script